import React, { createContext, useContext } from 'react';
import defaultConfig from '../config';

// Define the type for our config
export type Config = typeof defaultConfig;

// Create the context with undefined as the default value
const ConfigContext = createContext<Config | undefined>(undefined);

// Create the provider component that accepts config as a prop
export const ConfigProvider: React.FC<React.PropsWithChildren<{ config?: Config }>> = ({
  children,
  config = defaultConfig
}) => {
  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

// Create the hook to use the config
export const useConfig = () => {
  const context = useContext(ConfigContext);

  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }

  return context;
};

export default ConfigProvider;
